import { PropsWithChildren } from 'react';
import './DataListItem.scss';
// eslint-disable-next-line @typescript-eslint/ban-types
type Props = {};

const DataListItem = ({ children }: PropsWithChildren<Props>): JSX.Element => (
  <div className="table__row">{children}</div>);

export default DataListItem;
